import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ISettings } from './model';

const selectSettingFeat = createFeatureSelector<Readonly<ISettings>>('settings');

export const selectSetting = createSelector(selectSettingFeat, settings => settings);

export const selectAsideLeft = createSelector(selectSettingFeat, settings => settings.asideLeft);
export const selectAsideRight = createSelector(selectSettingFeat, settings => settings.asideRight);

export const selectOverlayOnRamper = createSelector(
  selectSettingFeat,
  (settings: ISettings) => settings.overlayOnRamper,
);
export const selectOverlayUploader = createSelector(
  selectSettingFeat,
  (settings: ISettings) => settings.overlayUploader,
);
export const selectOverlayBookmarks = createSelector(
  selectSettingFeat,
  (settings: ISettings) => settings.overlayBookmarks,
);
export const selectOverlayDraw = createSelector(selectSettingFeat, (settings: ISettings) => settings.overlayDraw);
export const selectOverlaySearcher = createSelector(
  selectSettingFeat,
  (settings: ISettings) => settings.overlaySearcher,
);
export const selectlobbyTab = createSelector(selectSettingFeat, (settings: ISettings) => settings.lobbyTabSelected);
export const selectOverlayLuckyCells = createSelector(
  selectSettingFeat,
  (settings: ISettings) => settings.overlayLuckyCells,
);
